var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { ContentPadding } from '@project/components/base';
import { PageContent } from '@project/components/Page';
import { Input, Label, Radio, Checkbox } from '../Forms/Fields';
import SelectForModal from '../Forms/Fields/SelectForModal';
import InputRenderer from '../InputRenderer';
import { Button } from '../Button/button.element';
import { P } from '../UI-helpers/typography';
import { ButtonWrapper } from '../../containers/StructureBuilderPage/styles';
var DEFAULT_VIEWPORT = {
    latitude: 57.698329,
    longitude: 11.9860685,
    zoom: 10,
    bearing: 0,
    pitch: 0,
};
var types = [
    'text',
    'timestamp',
    'number',
    'url',
    'image',
    'file',
    'boolean',
    'location',
    'json',
    'list',
];
var CreateConditionDialog = function (props) {
    var _a = useState(''), key = _a[0], setKey = _a[1];
    var _b = useState(''), initialKey = _b[0], setInitialKey = _b[1];
    var _c = useState(null), type = _c[0], setType = _c[1];
    var _d = useState({}), value = _d[0], setValue = _d[1];
    var _e = useState(1), sortDirection = _e[0], setSortDirection = _e[1];
    var _f = useState(false), isUpdate = _f[0], setIsUpdate = _f[1];
    var _g = useState(false), warning = _g[0], setWarning = _g[1];
    var _h = useState(true), isEmptyValue = _h[0], setIsEmptyValue = _h[1];
    useEffect(function () {
        var _a, _b;
        var _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if ((_c = props.condition) === null || _c === void 0 ? void 0 : _c.key) {
            setKey(props.condition.key);
            setInitialKey(props.condition.key);
            setType({
                value: (_d = props.condition) === null || _d === void 0 ? void 0 : _d.type,
                label: (_e = props.condition) === null || _e === void 0 ? void 0 : _e.type,
            });
            setSortDirection((_f = props.condition) === null || _f === void 0 ? void 0 : _f.sortDirection);
            setIsUpdate(true);
            var defKey = props.condition.key;
            if (typeof props.condition === 'object' &&
                'value' in props.condition &&
                props.condition.value !== null) {
                setIsEmptyValue(false);
            }
            if (((_g = props.condition) === null || _g === void 0 ? void 0 : _g.type) === 'location' && props.condition.value) {
                if (!('lat' in props.condition.value) &&
                    !('lon' in props.condition.value)) {
                    setIsEmptyValue(false);
                }
                setValue((_a = {},
                    _a[defKey] = __assign(__assign({}, (_h = props.condition) === null || _h === void 0 ? void 0 : _h.value), { viewport: __assign(__assign({}, DEFAULT_VIEWPORT), { latitude: (_j = props.condition.value) === null || _j === void 0 ? void 0 : _j.lat, longitude: (_k = props.condition.value) === null || _k === void 0 ? void 0 : _k.lon }) }),
                    _a));
            }
            else
                setValue((_b = {}, _b[defKey] = (_l = props.condition) === null || _l === void 0 ? void 0 : _l.value, _b));
        }
        else {
            setIsUpdate(false);
        }
    }, [props.condition]);
    var onKeyChange = function (_a) {
        var _b;
        var target = _a.target;
        var _c = props.existingConditionalObjs, existingConditionalObjs = _c === void 0 ? {} : _c;
        if (initialKey) {
            if (Object.keys(existingConditionalObjs).find(function (item) { return item === target.value; }) &&
                initialKey !== target.value)
                setWarning(true);
            else
                setWarning(false);
        }
        else {
            if (Object.keys(existingConditionalObjs).find(function (item) { return item === target.value; }))
                setWarning(true);
            else
                setWarning(false);
        }
        setValue((_b = {},
            _b[target.value] = value[key],
            _b));
        setKey(target.value);
    };
    var setEmptyValue = function (_a) {
        var target = _a.target;
        setIsEmptyValue(target.checked);
        if (target.checked) {
            setValue({});
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "pt-4" }, { children: _jsx(P, __assign({ black: true, bold: true, center: true, fontSize: 22 }, { children: "".concat(isUpdate ? 'Update' : 'Create', " conditional key") })) })), _jsx(PageContent, __assign({ modal: true }, { children: _jsxs(ContentPadding, __assign({ centered: true, noHeight: true }, { children: [_jsx(Label, { children: "Key" }), _jsx(Input, { value: key, onChange: onKeyChange }), warning && _jsxs(Label, __assign({ textColor: "#e0364a" }, { children: [key, " already exists"] })), _jsx(Label, { children: "Type" }), _jsx(SelectForModal, { margined: true, name: "type", value: type, options: types.map(function (t) { return ({
                                value: t,
                                label: t,
                            }); }), onChange: function (option) { return setType(option); } }), props.hasSortDirection && (_jsxs(_Fragment, { children: [_jsx(Label, { children: "Sort direction" }), _jsx(Radio, { options: [
                                        { id: 1, label: 'Ascending' },
                                        { id: -1, label: 'Descending' },
                                    ], name: "Sort direction", value: sortDirection, onChange: function (_a) {
                                        var target = _a.target;
                                        return setSortDirection(Number(target.value));
                                    } })] })), props.hasValue && (_jsxs(_Fragment, { children: [_jsx(Label, { children: "Value" }), _jsx(Checkbox, { label: "Empty value", checked: isEmptyValue, onChange: setEmptyValue }), _jsx(InputRenderer, { field: {
                                        type: type === null || type === void 0 ? void 0 : type.value,
                                        name: key,
                                    }, files: props.files, sendObject: value, setSendObject: setValue, disabled: isEmptyValue })] })), _jsxs(ButtonWrapper, { children: [_jsx(Button, __assign({ disable: warning, size: "small", type: "primary", onClick: function () {
                                        props.create(__assign(__assign({ key: key, type: type === null || type === void 0 ? void 0 : type.value }, (props.hasValue && {
                                            value: isEmptyValue ? null : value[key],
                                        })), (props.hasSortDirection && { sortDirection: sortDirection })));
                                    } }, { children: isUpdate ? 'Update' : 'Create' })), isUpdate && (_jsx("span", __assign({ style: { marginLeft: '10px' } }, { children: _jsx(Button, __assign({ size: "small", type: "danger", onClick: function () { return props.delete(initialKey); } }, { children: "Delete" })) })))] })] })) }))] }));
};
export default CreateConditionDialog;
